@let state = state$ | async;
@let call = state?.call;
@let minimized = minimized$ | async;
@let crm = crm$ | async;
@let elapsed = elapsed$ | async;

@if (call) {
  @let name = crm?.client?.name || call.displayName || call.number || 'Невідомий';

  @if (minimized && call.status !== 'ringing') {
    <!-- згорнуто: смужка зверху, торкання — назад на повний екран -->
    <div class="sp-pill" (click)="softphone.setMinimized(false)">
      <span class="sp-pill__dot" [class.sp-pill__dot--weak]="call.quality === 'weak'" [class.sp-pill__dot--bad]="call.quality === 'bad'"></span>
      <span class="sp-pill__time">{{ call.status === 'active' ? elapsed : call.status === 'calling' ? 'Виклик…' : 'З’єднуємо…' }}</span>
      <span class="sp-pill__name">{{ name }}</span>
      @if (call.muted) {
        <ion-icon class="sp-pill__muted" name="mic-off"></ion-icon>
      }
      <button class="sp-pill__end" aria-label="Завершити" (click)="$event.stopPropagation(); softphone.hangup()">
        <ion-icon name="call"></ion-icon>
      </button>
    </div>
  } @else {
    <div class="sp-screen" [class.sp-screen--ringing]="call.status === 'ringing'">
      <div class="sp-screen__top">
        @if (call.status !== 'ringing') {
          <button class="sp-icon-btn" aria-label="Згорнути" (click)="softphone.setMinimized(true)">
            <ion-icon name="chevron-down"></ion-icon>
          </button>
        }
        <span class="sp-screen__label">
          @switch (call.status) {
            @case ('ringing') { Вхідний дзвінок }
            @case ('connecting') { З’єднуємо… }
            @case ('calling') { Виклик… }
            @case ('active') { На зв’язку · {{ elapsed }} }
          }
          <!-- якість зв'язку: 3 зелені — добрий, 2 жовті — слабкий, 1 червона — поганий -->
          @if (call.status === 'active' && call.quality) {
            <span class="sp-signal sp-signal--{{ call.quality }}" [attr.aria-label]="'Якість зв’язку: ' + call.quality">
              <i></i><i></i><i></i>
            </span>
          }
        </span>
      </div>

      <div class="sp-caller">
        <div class="sp-caller__avatar">
          @if (crm?.client?.name || call.displayName) {
            {{ initials(name) }}
          } @else {
            <ion-icon name="call"></ion-icon>
          }
        </div>
        <div class="sp-caller__name">{{ name }}</div>
        @if (call.number && name !== call.number) {
          <div class="sp-caller__number">{{ call.number }}</div>
        }
        @if (call.status === 'active' && call.quality && call.quality !== 'good') {
          <div class="sp-caller__chip sp-caller__chip--{{ call.quality }}">
            <ion-icon name="cellular-outline"></ion-icon>
            {{ call.quality === 'bad' ? 'Поганий зв’язок' : 'Слабкий зв’язок' }}
          </div>
        }
        @if (call.note && call.status === 'calling') {
          <div class="sp-caller__chip">{{ call.note }}</div>
        }
        @if (crm?.street) {
          <div class="sp-caller__chip">
            <ion-icon name="location-outline"></ion-icon>
            {{ crm.street }}{{ crm.city ? ', ' + crm.city : '' }}
          </div>
        }
        @if (crm?.numberOfDoc) {
          <div class="sp-caller__chip">
            <ion-icon name="document-text-outline"></ion-icon>
            №{{ crm.numberOfDoc }}
          </div>
        }
      </div>

      @if (state?.message) {
        <div class="sp-screen__message">{{ state.message }}</div>
      }

      <div class="sp-actions">
        @if (call.status === 'ringing') {
          <div class="sp-action">
            <button class="sp-btn sp-btn--decline" aria-label="Відхилити" (click)="softphone.hangup()">
              <ion-icon name="call"></ion-icon>
            </button>
            <span>Відхилити</span>
          </div>
          <div class="sp-action">
            <button class="sp-btn sp-btn--answer" aria-label="Прийняти" (click)="softphone.answer()">
              <ion-icon name="call"></ion-icon>
            </button>
            <span>Прийняти</span>
          </div>
        } @else {
          <div class="sp-action">
            <button class="sp-btn sp-btn--glass" [class.sp-btn--on]="call.muted" aria-label="Мікрофон" (click)="softphone.toggleMute()">
              <ion-icon [name]="call.muted ? 'mic-off' : 'mic'"></ion-icon>
            </button>
            <span>{{ call.muted ? 'Увімкнути мікрофон' : 'Вимкнути мікрофон' }}</span>
          </div>
          @if (softphone.canToggleSpeaker) {
            <div class="sp-action">
              <button class="sp-btn sp-btn--glass" [class.sp-btn--on]="call.speaker" aria-label="Гучномовець" (click)="softphone.toggleSpeaker()">
                <ion-icon [name]="call.speaker ? 'volume-high' : 'volume-medium'"></ion-icon>
              </button>
              <span>Гучномовець</span>
            </div>
          }
          <div class="sp-action">
            <button class="sp-btn sp-btn--decline" aria-label="Завершити" (click)="softphone.hangup()">
              <ion-icon name="call"></ion-icon>
            </button>
            <span>Завершити</span>
          </div>
          <div class="sp-action">
            <button class="sp-btn sp-btn--glass" aria-label="Згорнути" (click)="softphone.setMinimized(true)">
              <ion-icon name="chevron-down"></ion-icon>
            </button>
            <span>Згорнути</span>
          </div>
        }
      </div>
    </div>
  }
}
